<template lang="pug">
  div.modal
    div.setLoading(v-if="preview === true")
      | <span>Loading...</span>
    div.setList(v-if="preview === false")
      header.header-modal
        .title
          | 組み合された商品
        .warning
          span 下記ボタンからお見積書、セット画像をダウンロードすることが出来ます。<br/>
              p(style="color: red; margin: 0") 画面内にシミュレーター全体が表示される状態にしてから画像ダウンロードをお願いします。<br/>
              | ※画面内に収まっていないと正常にダウンロードされない恐れがございます。
      div.content
        div.sets
          div.set(v-for="(n, i) in msets")
            div.tit
              //- | {{ nameCheck(n, i) }}
              | {{ n.name }}
              button(@click="del(i)")
                img(src="@/assets/ico_del.svg")
            div.caution(v-if="n.alert === true") この組み合わせは設置可能範囲を超えています。赤枠が表示されている組み合わせは申込みできません。
            label.setInr
              div.ipt
                input(type="checkbox",:disabled="inputDisabled(n.alert)",:value="i",name="selid",@change="selChange()")
                span
              div.info
                Item(v-for="(s, si) in n.items",:item="s",:key="si")
            div.price-area
              div.price
                | 計{{ n.qua }}点
                strong {{ addComma(n.price) }}
                | 円
              button.btn(@click="imgDownload(i)")
                img(src="@/assets/ico_download.svg")
                | 画像ダウンロード
              button.btn(@click="mtmDownload(i)")
                img(src="@/assets/ico_download.svg")
                | お見積書ダウンロード
      footer(:style="hasPremium ? 'justify-content:space-between' : 'justify-content: flex-end'")
        .warning-premiumCodeSet(v-if='hasPremium')
          |プレミアムパーツの金額は参考価格です。<br/>
          |価格は予告なしに変更する場合がございます。<br/>
        div.wrap-price
          div.price 合計<strong>{{ addComma(totalprice) }}</strong>円
          button(@click="form",:disabled="disabled()")
            | この組合せで申し込む
            img(src="@/assets/ico_arrow_right.svg")

    Form(v-if="formstatus")
    modal(name="alert",width="450",height="200",class="alert")
      div.alert-main
        div
          p 削除しますか？
          ul
            li
              button.btnNo(@click="no") いいえ
            li
              button.btnYes(@click="yes") はい

</template>

<script>
import domtoimage from 'dom-to-image';
import store from '../../stores';
import Form from '../form/Index';
import Item from './Item';
import axios from 'axios';
export default{
  name: 'ModalTotalSet',
  components: {
    Item,
    Form
  },
  data () {
    return {
      timer: {},
      count: 0,
      delid: 0,
      stockid: 0,
      totalprice: 0,
      selids: [],
      msets: [],
      formsets: {},
      // pview: 0,
      // color: 1
      hasPremium: false
    };
  },
  props: {

  },
  computed: {
  },
  methods: {
    nameCheck (n, num) {
      let cnt = 0;
      let name;
      for (let i = 0; i < Number(num); i++) {
        if (n.name === this.sets[i].name) {
          cnt++;
        }
      }
      if (cnt === 0) {
        name = n.name;
      } else {
        name = n.name + '(' + (cnt + 1) + ')';
      }
      return name;
    },
    del (num) {
      // store.commit('setView', 0);
      this.delid = num;
      this.$modal.show('alert');
      // if (this.$store.state.simulationInfo.id) {
      //   if (num === 0) {
      //     if (this.msets.length <= 2) {
      //       this.color = num;
      //     } else if (this.msets.length > 2) {
      //       this.color = num + 1;
      //     }
      //   } else if (this.msets.length - 1 === num) {
      //     this.color = num - 1;
      //   } else if (num < this.msets.length - 1 && num === this.$store.state.idx) {
      //     this.color = num - 1;
      //   }
      // }
    },
    no () {
      this.$modal.hide('alert');
      // store.commit('setView', 1);
    },
    yes () {
      let me = this;
      // let cnt = 1;
      // for (let prop in this.sets) {
      //   if (this.delid !== Number(prop)) {
      //     this.sets[prop].id = cnt;
      //     cnt++;
      //   }
      // }
      me.$modal.hide('alert');
      me.$emit('close');
      me.sets.splice(me.delid, 1);
      setTimeout(function () {
        if (me.number > 0) {
          if (me.number >= me.delid) {
            me.$router.push({path: '/' + me.number});
            store.commit('setId', me.number);
          }
        }
      }, 100);
      if (document.querySelector('.header select [value="' + me.id + '"]') !== null) {
        document.querySelector('.header select [value="' + me.id + '"]').selected = true;
        let evt = new Event('change');
        document.querySelector('.header select').dispatchEvent(evt);
      }
      // if (this.$store.state.simulationInfo.id && this.msets.length < 1) {
      //   store.commit('setColor', this.sets[this.color].color);
      // }
      // setTimeout(function () {
      //   store.commit('setView', 1);
      // }, 1000);
    },
    form () {
      let me = this;
      let inps = document.querySelectorAll('input:checked[name="selid"]');
      this.selids = [];
      for (const inp of inps) {
        this.selids.push(inp.value);
      }
      if (this.selids.length > 0) {
        this.count = 0;
        this.formsets = {};
        this.formsets.sets = [];
        this.pview = this.view;
        store.commit('setView', 1);
        this.stockid = this.number;
        me.formsets.sets = [];
        me.goToForm();
      }
    },
    close () {
      this.$emit('close');
    },
    domToImage (scale, width, height, transformOrigin = 'top left') {
      const domNode = document.querySelector('.contents .front');
      return domtoimage.toPng(domNode, {
        width: width,
        height: height,
        style: {
          transform: 'scale(' + scale + ')',
          transformOrigin: transformOrigin
        }
      });
    },
    createDomToImage () {
      let me = this;
      const domNode = document.querySelector('.contents .front');
      const scale = 1.6;
      const body = document.body;
      body.width = window.innerWidth;
      if (body.width > 2150) {
        return me.domToImage(1, domNode.clientWidth, body.width / 1.85);
      } else if (body.width < 1230) {
        if (window.innerHeight > 2000) {
          return me.domToImage(1, domNode.clientWidth * scale, domNode.clientHeight * 2, 'center center');
        } else {
          return me.domToImage(2, domNode.clientWidth * scale, domNode.clientHeight * scale);
        }
      } else {
        return me.domToImage(scale, domNode.clientWidth * scale, domNode.clientHeight * scale);
      }
    },
    imgDownload (id) {
      let me = this;
      let view = this.view;
      store.commit('setView', 1);
      store.commit('setId', id + 1);
      // me.sets.splice(me.id, 1, me.sets[me.number]);
      store.commit('setPreview', true);
      clearTimeout(me.timer);
      me.timer = setTimeout(function () {
        me.capCrop(id);
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          me.createDomToImage().then(function (dataUrl) {
            let downloadEle = document.createElement('a');
            downloadEle.href = dataUrl;
            downloadEle.download = me.sets[me.number].name + '.png';
            downloadEle.click();
            clearTimeout(me.timer);
            me.capCropDel();
            me.timer = setTimeout(function () {
              store.commit('setView', view);
              store.commit('setId', me.$route.params.id);
              store.commit('setPreview', false);
            }, 500);
          }).catch(function (error) {
            console.error('oops, something went wrong!', error);
          });
        }, 500);
      }, 1500);
    },
    capCrop (id) {
      let wt;
      let ht;
      let $front = document.querySelector('.contents .front');
      let $area = document.querySelector('.contents .front .area');
      let $frame = document.querySelector('.contents .front .frame');
      let $areaInr = document.querySelector('.contents .front .area-inr');
      let $underfloor = document.querySelector('.contents .front .underfloor');

      let areaWt = $area.offsetLeft + $areaInr.offsetLeft + $areaInr.offsetWidth;
      let frameWt = $area.offsetLeft + $frame.offsetLeft + $frame.offsetWidth;

      let areaHt = $underfloor.offsetHeight + $areaInr.offsetHeight + Math.round(this.c2p(this.sets[id].size[3]));
      let frameHt = $underfloor.offsetHeight + $frame.offsetHeight;

      if (areaWt < frameWt) {
        wt = frameWt + 250;
      } else {
        wt = areaWt + 250;
      }
      if (wt < 760) wt = 760;

      if (areaHt < frameHt) {
        ht = frameHt + 250;
      } else {
        ht = areaHt + 250;
      }
      if (ht < 760) ht = 760;
      $front.style.width = wt + 'px';
      $front.style.height = ht + 'px';
    },
    capCropDel () {
      let $front = document.querySelector('.contents .front');
      $front.style.width = '';
      $front.style.height = '';
    },
    goToForm () {
      let me = this;
      store.commit('setId', Number(this.selids[me.count]) + 1);
      store.commit('setPreview', true);
      clearTimeout(me.timer);
      me.timer = setTimeout(function () {
        me.capCrop(me.count);
        clearTimeout(me.timer);
        me.timer = setTimeout(function () {
          me.createDomToImage().then(function (canvas) {
            me.formsets.sets[me.count] = {};
            let itms = me.msets[me.selids[me.count]];
            let obj = [];
            for (let prop in itms.items) {
              obj.push({
                id: itms.items[prop].id,
                quantity: itms.items[prop].qua
              });
            }
            me.formsets.sets[me.count].name = itms.name;
            me.formsets.sets[me.count].items = obj;
            me.formsets.sets[me.count].img = canvas;
            me.count++;
            if (me.count >= me.selids.length) {
              me.count = 0;
              clearTimeout(me.timer);
              me.capCropDel();
              me.timer = setTimeout(function () {
                // let cid = me.$router.history.current.params.id;
                store.commit('setPreview', false);
                store.commit('setFormstatus', true);
                store.commit('setForms', me.formsets);
                // me.$router.push({ path: '/' + cid + '/form' });
                // me.$router.push({ path: '/form' });
                store.commit('setId', me.$route.params.id);
                console.log(me.formsets);
              }, 500);
            } else {
              me.goToForm();
            }
          });
        }, 500);
      }, 1500);
    },
    mtmDownload (id) {
      let me = this;
      let obj = {};
      obj.name = this.msets[id].name;
      obj.items = [];
      for (let prop in this.msets[id].items) {
        obj.items.push({
          id: this.msets[id].items[prop].id,
          quantity: this.msets[id].items[prop].qua
        });
      }
      store.commit('setPreview', true);
      let url;
      if (this.config.type === 'c') {
        url = '/api/btoc/export-pdf';
      } else {
        this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
        url = '/api/export-pdf';
      }
      axios.post(this.config.baseURL + url, obj, this.axiosConfig).then(function (response) {
        me.download(response);
      });
      // if (!this.dev) {
      // } else {
      //   axios.get(this.config.baseURL + url, obj, this.axiosConfig).then(function (response) {
      //     me.download(response);
      //   });
      // }
    },
    selChange () {
      let inps = document.querySelectorAll('input:checked[name="selid"]');
      this.selids = [];
      for (const inp of inps) {
        this.selids.push(Number(inp.value));
      }
    },
    download (response) {
      let downloadEle = document.createElement('a');
      downloadEle.href = response.data.data.download;
      downloadEle.download = response.data.data.download;
      downloadEle.target = 'blank';
      downloadEle.click();
      store.commit('setPreview', false);
    },
    disabled () {
      if (this.selids.length > 0) {
        return false;
      } else {
        return 'disabled';
      }
    },
    inputDisabled (alert) {
      return alert;
    },
    totalCheck () {
      for (let prop in this.sets) {
        let ary = [];
        let set = this.sets[prop];
        if (set !== undefined) {
          // let name = set.name;
          let name1 = set.name1;
          for (let prop in set.rails) {
            let obj = {};
            let chk;
            let rails = set.rails[prop];
            const isLargeNumber = (element) => element.id === rails.id;
            chk = ary.findIndex(isLargeNumber);
            if (chk === -1) {
              obj = this.acopy(rails);
              obj.qua = 1;
              obj.w = obj.w + 1.5; // レールは横幅1.5cm足す
              ary.push(obj);
            } else {
              ary[chk].qua = ary[chk].qua + 1;
            }
          }
          for (let prop2 in set.slits) {
            let obj = {};
            let chk;
            let slits = set.slits[prop2];
            if(slits.display !== false) {
              if (slits.slit !== undefined) {
                const isLargeNumber = (element) => element.id === slits.slit.id;
                chk = ary.findIndex(isLargeNumber);
                if (chk === -1) {
                  obj = this.acopy(slits.slit);
                  obj.qua = 1;
                  obj.h = obj.pos
                  ary.push(obj);
                } else {
                  obj.h = obj.pos
                  ary[chk].qua = ary[chk].qua + 1;
                }
              }
            }
            if (slits.item.length > 0) {
              for (let prop3 in slits.item) {
                if (slits.item[prop3].display) {
                  const isLargeNumber = (element) => element.id === slits.item[prop3].id;
                  chk = ary.findIndex(isLargeNumber);
                  if (chk === -1) {
                    obj = this.acopy(slits.item[prop3]);
                    obj.qua = 1;
                    obj.h = obj.pos;
                    ary.push(obj);
                  } else {
                    ary[chk].qua = ary[chk].qua + 1;
                    obj.h = obj.pos;
                  }
                }
              }
            }
            for (let prop3 in slits.floor) {
              if (slits.floor[prop3].display) {
                const isLargeNumber = (element) => element.id === slits.floor[prop3].id;
                chk = ary.findIndex(isLargeNumber);
                if (chk === -1) {
                  obj = this.acopy(slits.floor[prop3]);
                  obj.qua = 1;
                  ary.push(obj);
                } else {
                  ary[chk].qua = ary[chk].qua + 1;
                }
              }
            }
          }
          let price = 0;
          let qua = 0;
          for (let prop in ary) {
            price += ary[prop].price * ary[prop].qua;
            qua += ary[prop].qua;
          }
          this.msets.push({
            // name: name,
            name: name1,
            price: price,
            qua: qua,
            items: ary,
            alert: this.sets[prop].alert
          });
        }
        const checkPremium = (items) => {
          return items.some(item =>
            item.is_premium === 1
          );
        };
        if (checkPremium(this.msets[prop].items)) {
          this.hasPremium = true;
        }
      }
      this.totalprice = 0;
      for (let prop in this.msets) {
        this.totalprice += this.msets[prop].price;
      }
    }
  },
  created () {
    let me = this;
    setTimeout(function () {
      me.totalCheck();
    }, 100);
  },
  mounted () {
    document.querySelector('body').appendChild(this.$el.parentNode.parentNode);
    this.$el.parentNode.parentNode.querySelector('.vm--overlay').style.pointerEvents = 'none';
  }
};
</script>

<style lang="stylus" scoped>
  .modal
    header
      margin 0
      padding 5px 30px
      font-size 20px
      font-weight bold
      border-bottom 1px solid #dddddd
      display flex
      align-items center
      span
        font-weight normal
        font-size 10px
        color #777777
        display inline-block
        margin-left 20px
    footer
      position absolute
      left 0
      right 0
      bottom 0
      height 73px
      padding 20px 30px
      border-top 1px solid #dddddd
      display flex
      align-items center
      .price
        font-weight bold
        font-size 12px
        margin-right 20px
        strong
          color #FF4E00
          display inline-block
          margin-left 20px
      button
        background-color #2E7C80
        width 200px
        height 33px
        border none
        border-radius 5px
        color #ffffff
        font-weight bold
        font-size 14px
        &[disabled]
          background-color #aaaaaa
          &:hover
            opacity 1
        img
          display inline-block
          vertical-align middle
          margin-left 5px
          margin-top -2px
    .content
      display flex
      padding 0 30px
      background-color #ffffff
      position absolute
      left 0
      right 0
      top 72px
      bottom 73px
      overflow-y auto
      margin 20px 0
      .txt
        font-size 14px
        padding-top 30px
    .sets
      width 100%
    .set
      padding-bottom 20px
      margin-bottom 20px
      border-bottom 1px solid #dddddd
      &:last-child
        border-bottom none
      .setInr
        display flex
        align-items center
        &:hover
          opacity 1
          .info
            opacity 0.7
        .ipt
          padding 5px
          overflow hidden
          position relative
          input
            position absolute
            background-color #ffffff
            left -999px
          input + span
            display flex
            justify-content center
            align-items center
            width 20px
            height 20px
            border 1px solid #aaaaaa
            border-radius 3px
          input:checked + span:before
            content ""
            display block
            width 12px
            height 12px
            border-radius 3px
            background-color #2e7c80
          input[disabled="disabled"] + span
            border 1px solid #cc0000

        .info
          flex 1
          /*user-select none*/
      .tit
        font-size 18px
        font-weight bold
        &:after
          content ""
          display table
          clear both
        button
          float right
          border 1px solid #707070
          background-color #ffffff
          border-radius 5px
          width 34px
          height 34px
      .caution
        color #cc0000
        font-size 12px
        font-weight bold
        margin-bottom 5px
      .price-area
        display flex
        justify-content flex-end
        align-items center
        .price
          font-size 12px
          font-weight bold
          strong
            color #FF4E00
            display inline-block
            margin-left 20px
        .btn
          width 175px
          height 33px
          border 1px solid #2E7B80
          color #2E7B80
          border-radius 3px
          background-color #ffffff
          font-size 12px
          font-weight bold
          margin-left 15px
          img
            display inline-block
            vertical-align middle
            margin-right 7px
            margin-top -2px
    .warning-premiumCodeSet
      font-size 12px
    .wrap-price
      display flex
      align-items center
  .setLoading
    position absolute
    left 0
    top 0
    width 100%
    height 100%
    display flex
    justify-content center
    align-items center
    span
      animation flash 1s linear infinite
  .alert
    .vm--modal
      width 450px !important
      height 200px !important
    .alert-main
      position absolute
      left 0
      right 0
      top 0
      bottom 0
      display flex
      justify-content center
      align-items center
    p
      margin-bottom 20px
      text-align center
      font-size 14px
    ul
      display flex
      justify-content center
      .btnNo
        width 130px
        height 33px
        border 1px solid #2E7B80
        color #2E7B80
        border-radius 3px
        background-color #ffffff
        font-size 12px
        font-weight bold
        margin-left 15px
      .btnYes
        width 130px
        height 33px
        border 1px solid #2E7B80
        color #FFFFFF
        border-radius 3px
        background-color #2E7B80
        font-size 12px
        font-weight bold
        margin-left 15px
@keyframes flash
  0%
    opacity 1
  50%
    opacity: 0;
  100%
    opacity: 1;
</style>



// WEBPACK FOOTER //
// src/components/total/ModalTotalSet.vue